/** @jsx h */
// ═══════════════════════════════════════════════════════
//  Theme Utility — Dark/Light Mode Toggle
// ═══════════════════════════════════════════════════════

const THEME_KEY = 'literaljs-theme';

/**
 * Get the effective theme.
 * Priority:
 *  1. Saved localStorage preference
 *  2. OS prefers-color-scheme (dark → dark, otherwise light)
 *  3. Fallback to 'light'
 */
export function getTheme() {
	const saved = localStorage.getItem(THEME_KEY);
	if (saved) return saved;

	if (typeof window !== 'undefined' && window.matchMedia) {
		return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
	}

	return 'light';
}

export function setTheme(theme) {
	localStorage.setItem(THEME_KEY, theme);
	document.documentElement.setAttribute('data-theme', theme);
	if (typeof window !== 'undefined') {
		window.dispatchEvent(new CustomEvent('literaljs:themechange', { detail: { theme } }));
	}
}

export function toggleTheme() {
	const current = getTheme();
	const next = current === 'dark' ? 'light' : 'dark';
	setTheme(next);
	return next;
}

export function initTheme() {
	const saved = getTheme();
	document.documentElement.setAttribute('data-theme', saved);
}
